

import { FC, useState, ReactNode, useRef, useEffect } from 'react'
import DatePicker from "react-datepicker";
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import '../../../assets/css/datepicker.css'
import closeBtn from '../../../assets/images/close-btn.svg';

interface Props {
    title: string,
    step: number,
    closeModal: () => void
    selectDate: (date: Date[]) => void
    handleBBDateSelection: () => void
}

const DatePickerModal: FC<Props> = ({ title, step, closeModal, selectDate, handleBBDateSelection }) => {

    const calendarRef = useRef<any>(null);
    const startCalendarRef = useRef<any>(null);
    const endCalendarRef = useRef<any>(null);
    const [selectedDate, setSelectedDate] = useState<Date[]>([
        moment().subtract(1, 'month').startOf('month').toDate(),
        moment().subtract(1, 'month').endOf('month').toDate()
    ]);
    const [maxDate, setMaxDate] = useState<Date>(selectedDate[0])

    const _handleSelectDate = (date: Date[]) => {
        setSelectedDate(date)
        selectDate(date);
    }

    const openCalendar = () => {
        if (calendarRef.current) {
            calendarRef.current?.setOpen(true)
        }
    }
    const startOpenCalendar = () => {
        if (startCalendarRef.current) {
            startCalendarRef.current?.setOpen(true)
        }
    }
    const endOpenCalendar = () => {
        if (endCalendarRef.current) {
            endCalendarRef.current?.setOpen(true)
        }
    }

    const _handleSubmitModal = () => {
        if (selectedDate) {
            selectDate(selectedDate);
            handleBBDateSelection()
            closeModal();
        }
    }

    const _handleCloseModal = () => {
        closeModal();
        selectDate([]);
    }

    useEffect(() => {
        if (step == 3) {
            const maxdate = selectedDate[0] ? moment(selectedDate[0]).add(5, 'months').endOf('month').toDate() : moment().subtract(1, 'month').endOf('month').toDate();

            const currentDate = moment().startOf('month');
            const maxdateDate = moment(maxdate);

            if (moment(maxdateDate).isBefore(currentDate)) {
                setMaxDate(maxdate);
                setSelectedDate([selectedDate[0], maxdate]);
                selectDate([selectedDate[0], maxdate]);
            } else {
                setMaxDate(moment(currentDate).subtract(1, 'day').toDate());
                setSelectedDate([selectedDate[0], moment(currentDate).subtract(1, 'day').toDate()]);
                selectDate([selectedDate[0], moment(currentDate).subtract(1, 'day').toDate()]);
            }
        }
    }, [selectedDate[0]])

    return (
        <Modal show={true} onHide={_handleCloseModal} backdrop="static" animation={false} size="lg">
            <div className="">
                <div className="">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">{title}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={_handleCloseModal}><img src={closeBtn} alt="" /></button>
                    </div>
                    <div className="modal-body pb-0">
                        {
                            step == 2 ? (
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group date-picker-container">
                                            <label htmlFor="">Select Date<strong className='text-danger'>*</strong></label>
                                            <DatePicker
                                                ref={calendarRef}
                                                selected={moment(selectedDate[0]).endOf('month').toDate()}
                                                onChange={(date: Date) => _handleSelectDate([date])}
                                                className='form-control'
                                                dateFormat={'MM/dd/yyyy'}
                                                maxDate={moment().subtract(1, 'month').endOf('month').toDate()}
                                                showMonthYearPicker
                                                calendarIconClassname='tex-end'
                                                onKeyDown={(e) => e.preventDefault()}
                                            />

                                            <i className="fa fa-calendar fa-2xl cursor-pointer calendar-icon" aria-hidden="true" onClick={openCalendar}></i>
                                        </div>
                                    </div>
                                </div>
                            ) : step == 3 ? (
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="filter-wrap">
                                            <div className="d-flex">
                                                <div className="form-group date-picker-container">
                                                    <label htmlFor="">Start Date</label>
                                                    <DatePicker
                                                        ref={(el) => startCalendarRef}
                                                        selected={moment(selectedDate[0]).toDate()}
                                                        onChange={(date: Date) => _handleSelectDate([date, selectedDate[1]])}
                                                        className='form-control'
                                                        dateFormat={'MM/dd/yyyy'}
                                                        maxDate={moment().subtract(1, 'month').endOf('month').toDate()}
                                                        calendarIconClassname='tex-end'
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        yearDropdownItemNumber={40}
                                                        showMonthDropdown
                                                        onKeyDown={(e) => e.preventDefault()}
                                                    />

                                                    <i className="fa fa-calendar fa-2xl cursor-pointer calendar-icon" aria-hidden="true" onClick={startOpenCalendar}></i>
                                                </div>
                                                &nbsp;&nbsp;&nbsp;

                                                <div className="form-group date-picker-container">
                                                    <label htmlFor="">End Date</label>
                                                    <DatePicker
                                                        ref={(el) => endCalendarRef}
                                                        selected={moment(selectedDate[1]).toDate()}
                                                        onChange={(date: Date) => _handleSelectDate([selectedDate[0], date])}
                                                        className='form-control'
                                                        dateFormat={'MM/dd/yyyy'}
                                                        minDate={moment(selectedDate[0]).toDate()}
                                                        maxDate={maxDate}
                                                        calendarIconClassname='tex-end'
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        yearDropdownItemNumber={40}
                                                        showMonthDropdown
                                                        onKeyDown={(e) => e.preventDefault()}
                                                    />

                                                    <i className="fa fa-calendar fa-2xl cursor-pointer calendar-icon" aria-hidden="true" onClick={endOpenCalendar}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <small className="text-muted">
                                            <i className="fa fa-exclamation-triangle text-warning me-1" data-bs-toggle="tooltip" data-bs-placement="top"></i>
                                            You can import a maximum of 6 months' data in a single request for Balance Sheet or Profit & Loss reports. For longer periods, please split the import into multiple batches.
                                        </small>
                                    </div>
                                </div>
                            ) : <></>
                        }
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" onClick={_handleCloseModal}>Close</button> &nbsp;
                        <button type="button" className="btn btn-primary" onClick={_handleSubmitModal}>
                            Continue
                        </button>
                    </div>
                </div>
            </div>
            {/* </div> */}
        </Modal>
    )
}

export default DatePickerModal;